import { IconContent } from '@icons';

export const vocabulariesFilled: IconContent = {
    md: '<path d="M14 4.764 17.927 4l.729 3.751-3.874 1.038L14 4.764Zm.974 5.009 1.793 9.224 3.926-.763-1.846-9.499-3.873 1.038ZM8 5H4v3.81h4V5Zm1 0v3.81h4V5H9Zm4 4.81H9V19h4V9.81ZM8 19V9.81H4V19h4Zm13 1H3v1h18v-1Z" />',
};
